import { TProductRateValue } from '@lib/core/users/slices/productRate';
import { localeCommon } from '@lib/tools/locale/source/web/common';
import { localeWidget } from '@lib/tools/locale/source/web/widget';
import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';

import rating1Active from '@components/web/src/assets/icons/productRate/rating1Active.png';
import rating1Inactive from '@components/web/src/assets/icons/productRate/rating1Inactive.png';
import rating2Active from '@components/web/src/assets/icons/productRate/rating2Active.png';
import rating2Inactive from '@components/web/src/assets/icons/productRate/rating2Inactive.png';
import rating3Active from '@components/web/src/assets/icons/productRate/rating3Active.png';
import rating3Inactive from '@components/web/src/assets/icons/productRate/rating3Inactive.png';
import rating4Active from '@components/web/src/assets/icons/productRate/rating4Active.png';
import rating4Inactive from '@components/web/src/assets/icons/productRate/rating4Inactive.png';
import rating5Active from '@components/web/src/assets/icons/productRate/rating5Active.png';
import rating5Inactive from '@components/web/src/assets/icons/productRate/rating5Inactive.png';

// ! Refactor below
// Dev tools
export const URL_PARAM_TOOLS = 'tools';

// Unit test variable
export const RTL_SLUG_FOR_TESTS = 'RTL_SLUG_FOR_TESTS';

// ! Quizzes and Routes - use quizTypes in a route map

// Retailer const
export const STORE = 'store-character';
export const RETAILER_SLUG_FOR_REPLACEMENT = ':retailer_slug';
export const UID_REPLACEMENT = ':uid';
export const TOKEN_REPLACEMENT = ':token';
export const EMAIL_HASH_REPLACEMENT = ':email_hash';
export const RETAILER_LOCATION_SLUG_FOR_REPLACEMENT = ':retailerLocationSlug';
export const EDUTAINMENT_FORM_LINK_REPLACEMENT = ':typeformLink';
export const PRODUCT_CATEGORY_REPLACEMENT = ':productCategory';

// Flash label constants - Vusion API
export const STORE_ID_REPLACEMENT = ':store_id';
export const ITEM_ID_REPLACEMENT = ':item_id';

// Quiz constants
export const QUIZ_SESSION_ID_REPLACEMENT = ':quiz_session_id';

// @ts-ignore
export const isApplicationKiosk = import.meta.env.REACT_APP_IS_KIOSK === 'true';
// @ts-ignore
export const isApplicationPmi = import.meta.env.REACT_APP_IS_PMI === 'true';

export const ENV_IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION === 'true';
export const ENV_IS_TESTING = process.env.MOCK_STORE === 'true';
export const ENV_IS_BUILD = process.env.NODE_ENV === 'production';

export const ENV_APPLE_APP_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
export const ENV_APPLE_REDIRECT_URL = process.env.REACT_APP_APPLE_REDIRECT_URL;
export const ENV_FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const ENV_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const ENV_DEVTOOLS_TOKEN = process.env.REACT_APP_DEVTOOLS_TOKEN;
export const ENV_GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID;
export const ENV_HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;
export const ENV_FACEBOOK_PIXEL_ID = process.env.REACT_APP_FACEBOOK_PIXEL_ID;
export const ENV_TRACKING_BLACKLIST = process.env.REACT_APP_TRACKING_BLACKLIST;

export const ENV_DYNAMIC_ENV_DOMAINS = process.env.REACT_APP_DYNAMIC_ENV_DOMAINS;

const ENV_VINHOOD_CF_DOMAIN = isApplicationKiosk
  ? process.env.REACT_APP_AWS_CF_DOMAIN_KIOSK
  : process.env.REACT_APP_AWS_CF_DOMAIN_WEB;

export const ENV_CLOUDFRONT_APP_DOMAIN = isApplicationPmi
  ? process.env.REACT_APP_AWS_CF_DOMAIN_FA
  : ENV_VINHOOD_CF_DOMAIN;

export const ENV_TEST_APP_DOMAIN = '.app.vinhood.dev';
export const ENV_TEST_KIOSK_DOMAIN = '.kiosk.vinhood.dev';
export const ENV_PROD_DOMAIN = `https://api.${isApplicationPmi ? 'taste-advisor-vh' : 'vinhood'}.com`;
export const ENV_DEV_DOMAIN = `https://develop${isApplicationPmi ? '-ta' : '-vh'}.api.vinhood.dev`;

export const ENV_BACKEND_DOMAIN = ENV_IS_PRODUCTION ? ENV_PROD_DOMAIN : ENV_DEV_DOMAIN;

export const ENV_MEDIA_DOMAIN = `https://media${ENV_IS_PRODUCTION ? '' : '-staging'}.vinhood.com/media${isApplicationPmi ? '-ta' : ''}`;

export const ENV_MEDIA_CONTENT_DOMAIN = `${ENV_MEDIA_DOMAIN}/content`;

// * Design Sets
export const DESIGN_SET_PMI_V2 = 'taste-advisor-v2';
export const DESIGN_SET_PMI_CRAFTED = 'taste-advisor-crafted';
export const DESIGN_SET_WINE_EXPERIENCE = 'wine-experience';
export const DESIGN_SET_VINHOOD_APP = 'vinhood-app';
export const DESIGN_SET_VINHOOD_EXPERIENCE = 'vinhood-experience';
export const DESIGN_SET_VINHOOD_KIOSK = 'vinhood-kiosk';

// local storage
export const STATE = 'state';

// request errors
export const REQUEST_ERROR_FORBIDDEN_MESSAGE = 'Your IP is not allowed for this API.';
export const REQUEST_ERROR_MARKET_DEACTIVATION_CODE = '410';
export const REQUEST_ERROR_404 = '404';
export const REQUEST_ERROR_400 = '400';
export const REQUEST_ERROR_422 = '422';
export const REQUEST_ERROR_502 = '502';
export const REQUEST_ERROR_504 = '504';

// Console warnings
export const ERROR_UNRECOGNIZED_POST_MESSAGE_EVENT = 'WarningUnrecognizedPostMessageEvent';

// for B2C tabs in profile page
export const PROFILE_TAB_SLUG_REPLACEMENT = ':profileSlug?';
// for Widget tabs in legal page
export const LEGAL_TAB_SLUG_REPLACEMENT = ':legalTabSlug?';

// Global SearchTypes
export const GLOBAL_SEARCH_TYPES = {
  articles: 'articles',
  experiences: 'experiences',
  products: 'products',
};

export const GET_PRODUCTS_REQUEST_LIMIT = 20;

export const PRODUCT_SLUG_REPLACEMENT = 'product-slug';

// Experiences Catalog
export const EXPERIENCES_TYPES = {
  courses: 'EXT0004',
  events: 'EXT0006',
  experiences: 'EXT0002',
  onlineActivities: 'EXT0003',
  onlineClasses: 'EXT0005',
  overnightStays: 'EXT0007',
  tastings: 'EXT0001',
};

// HTTP Request methods
export const REQUEST_METHODS = {
  DELETE: 'DELETE',
  GET: 'GET',
  OPTIONS: 'OPTIONS',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
};

export const BrowserUrlConsts = {
  actionPerformed: 'actionPerformed',
  activePanelFilter: 'activePanelFilter',
  activeResultCatalogTab: 'activeResultCatalogTab',
  character: 'character',
  characters: 'characters',
  currentDateDay: 'currentDateDay',
  disableUserCharacterToggle: 'disableUserCharacterToggle',
  enablePromotionToggle: 'enablePromotionToggle',
  enableWishlistFilter: 'enableWishlistFilter',
  fidelityId: 'fidelityID',
  isFromExplorePage: 'isFromExplorePage',
  isFromKioskQr: 'isQR',
  isFromKioskTestResultView: 'isFromKioskTestResultView',
  isFromProductDetailsPage: 'isFromProductDetails',
  isFromRecipeSearch: 'isFromRecipeSearch',
  isFromRecipeTest: 'isFromRecipeTest',
  isFromSituationalTest: 'isFromSituationalTest',
  isFromTastePath: 'isFromTastePath',
  mixpanelEventSlug: 'mixpanelEventSlug',
  mood: 'mood',
  preferences: 'preferences',
  preselected: 'preselected',
  product: 'product',
  productCategory: 'productCategory',
  productId: 'productID',
  productIds: 'productIDs',
  productPreferences: 'situationalPreferences',
  redirectUrl: 'redirectUrl',
  registrationUrlParam: 'registrationUrlParam',
  retailerLocationId: 'retailerLocationId',
  retailerSlug: 'retailerSlug',
  shouldRedirectToProductPage: 'shouldRedirectToProductPage',
  situationalPreferences: 'situationalPreferences',
  situationalPreselected: 'preselected',
  situationalPreselectedProductCategory: 'preselectedProductCategory',
  startEmailRegistration: 'startEmailRegistration',
  tab: 'tab',
} as const;

export const ApiQueries = {
  associatedRetailerSlug: 'associated_retailer_location_slug',
  character: 'character_identifier',
  characterTypeSlug: 'characterType_slug',
  characteristics: 'product_characteristics_identifier',
  dietaryPreference: 'dietary_preference',
  formats: 'product_format_identifier',
  moods: 'user_product_preferences',
  ordering: 'priority',
  origins: 'product_region_identifier',
  positionsIdentifier: 'positions_identifier',
  preferences: 'preferences_slug',
  priceMax: 'price_lte',
  priceMin: 'price_gte',
  producerIdentifier: 'producer_identifier',
  productCategory: 'product_category',
  productCategoryName: 'productCategory_name',
  productIdentifier: 'product_identifier',
  productName: 'query',
  promotions: 'promotions_typeSlug',
  retailerLocation: 'retailer_location',
  styles: 'character_type_identifier',
} as const;

export const ApiValues = {
  emptyHintForProducts: 'empty',
  orderingByPrice: 'price',
  orderingByRank: 'rank',
  productName: 'product_name',
  promotionByLabel: 'label',
  promotionFeature: 'featured',
} as const;

export const HARDCODED_PRODUCT_RATE_DATA: Record<
  TProductRateValue,
  {
    icon: { activeIcon: string; inactiveIcon: string };
    colors: { borderColor: string; backgroundColor: string };
    text: ILocaleText;
    value: TProductRateValue;
  }
> = {
  10: {
    colors: { backgroundColor: '#FFE7E5', borderColor: '#FF9992' },
    icon: { activeIcon: rating1Active, inactiveIcon: rating1Inactive },
    text: localeCommon.ratingModal.ratingVeryBad,
    value: 10,
  },
  20: {
    colors: { backgroundColor: '#FFF2E4', borderColor: '#FFA337' },
    icon: { activeIcon: rating2Active, inactiveIcon: rating2Inactive },
    text: localeCommon.ratingModal.ratingBad,
    value: 20,
  },
  30: {
    colors: { backgroundColor: '#FFFDDE', borderColor: '#FFD000' },
    icon: { activeIcon: rating3Active, inactiveIcon: rating3Inactive },
    text: localeCommon.ratingModal.ratingNeutral,
    value: 30,
  },
  40: {
    colors: { backgroundColor: '#F6FFDE', borderColor: '#BCD446' },
    icon: { activeIcon: rating4Active, inactiveIcon: rating4Inactive },
    text: localeCommon.ratingModal.ratingGood,
    value: 40,
  },
  50: {
    colors: { backgroundColor: '#F2F9F5', borderColor: '#24A360' },
    icon: { activeIcon: rating5Active, inactiveIcon: rating5Inactive },
    text: localeCommon.ratingModal.ratingVeryGood,
    value: 50,
  },
};

// Taste Match
export const TASTE_MATCH_LEVELS = {
  FOUR: 'levelFour',
  NONE: 'levelNone',
  ONE: 'levelOne',
  THREE: 'levelThree',
  TWO: 'levelTwo',
} as const;

// These are specific scenarios which are controlled (so far) by entrypoint URL
export const SERVICE_INSTANCES_TYPES = {
  isServiceInstanceDutyFree: 'isServiceInstanceDutyFree',
  isServiceInstanceShortRecommender: 'isServiceInstanceShortRecommender',
} as const;
export type TServiceInstanceType = (typeof SERVICE_INSTANCES_TYPES)[keyof typeof SERVICE_INSTANCES_TYPES];

export const TASTE_MATCH_LEVEL_VALUES = {
  [TASTE_MATCH_LEVELS.ONE]: { max: 1, min: 0.96 },
  [TASTE_MATCH_LEVELS.TWO]: { max: 0.95, min: 0.8 },
  [TASTE_MATCH_LEVELS.THREE]: { max: 0.79, min: 0.6 },
  [TASTE_MATCH_LEVELS.FOUR]: { max: 0.59, min: 0 },
  [TASTE_MATCH_LEVELS.NONE]: { max: null, min: null },
};

export type TTasteMatchLevels = (typeof TASTE_MATCH_LEVELS)[keyof typeof TASTE_MATCH_LEVELS];

// Maximum number of products in the Kiosk Result Catalog with Test Result View
export const TEST_RESULT_VIEW_MAX_PRODUCTS = 3;

export const CATALOG_TABS = {
  ALL_PRODUCTS: {
    defaultText: localeCommon.commonMessages.allProductsTab.defaultMessage,
    tabCode: 'ALL_PRODUCTS',
    text: localeCommon.commonMessages.allProductsTab,
  },
  CT0001: {
    defaultText: localeCommon.commonMessages.sparklingsTab.defaultMessage,
    tabCode: 'CT0001',
    text: localeCommon.commonMessages.sparklingsTab,
  },
  CT0002: {
    defaultText: localeCommon.commonMessages.redsTab.defaultMessage,
    tabCode: 'CT0002',
    text: localeCommon.commonMessages.redsTab,
  },
  CT0003: {
    defaultText: localeCommon.commonMessages.whitesTab.defaultMessage,
    tabCode: 'CT0003',
    text: localeCommon.commonMessages.whitesTab,
  },
  CT0004: {
    defaultText: localeCommon.commonMessages.sweetsTab.defaultMessage,
    tabCode: 'CT0004',
    text: localeCommon.commonMessages.sweetsTab,
  },
  CT0005: {
    defaultText: localeCommon.commonMessages.rosesOrangesTab.defaultMessage,
    tabCode: 'CT0005',
    text: localeCommon.commonMessages.rosesOrangesTab,
  },
  CT0006: {
    defaultText: localeCommon.commonMessages.unconventialTab.defaultMessage,
    tabCode: 'CT0006',
    text: localeCommon.commonMessages.unconventialTab,
  },
  CT0007: {
    defaultText: localeCommon.commonMessages.bitterTab.defaultMessage,
    tabCode: 'CT0007',
    text: localeCommon.commonMessages.bitterTab,
  },
  CT0008: {
    defaultText: localeCommon.commonMessages.creamyTab.defaultMessage,
    tabCode: 'CT0008',
    text: localeCommon.commonMessages.creamyTab,
  },
  CT0009: {
    defaultText: localeCommon.commonMessages.refreshingTab.defaultMessage,
    tabCode: 'CT0009',
    text: localeCommon.commonMessages.refreshingTab,
  },
  CT0010: {
    defaultText: localeCommon.commonMessages.intenseTab.defaultMessage,
    tabCode: 'CT0010',
    text: localeCommon.commonMessages.intenseTab,
  },
  CT0011: {
    defaultText: localeCommon.commonMessages.acidAndRomaticTab.defaultMessage,
    tabCode: 'CT0011',
    text: localeCommon.commonMessages.acidAndRomaticTab,
  },
  CT0012: {
    defaultText: localeCommon.commonMessages.delicateTab.defaultMessage,
    tabCode: 'CT0012',
    text: localeCommon.commonMessages.delicateTab,
  },
  KIOSK_RESULT: {
    defaultText: localeCommon.commonMessages.yourTasteTab.defaultMessage,
    tabCode: 'KIOSK_RESULT',
    text: localeCommon.commonMessages.yourTasteTab,
  },
  RECIPE_SEARCH_RESULT: {
    defaultText: localeCommon.commonMessages.forYourRecipeTab.defaultMessage,
    tabCode: 'RECIPE_SEARCH_RESULT',
    text: localeCommon.commonMessages.forYourRecipeTab,
  },
  RECIPE_TEST_RESULT: {
    defaultText: localeCommon.commonMessages.forYourMealTab.defaultMessage,
    tabCode: 'RECIPE_TEST_RESULT',
    text: localeCommon.commonMessages.forYourMealTab,
  },
  SITUATIONAL_RESULT: {
    defaultText: localeCommon.commonMessages.yourOccasionTab.defaultMessage,
    tabCode: 'SITUATIONAL_RESULT',
    text: localeCommon.commonMessages.yourOccasionTab,
  },
  YOUR_TASTE_PATH: {
    defaultText: localeWidget.tabs.yourTastePathTab.defaultMessage,
    tabCode: 'YOUR_TASTE_PATH',
    text: localeWidget.tabs.yourTastePathTab,
  },
  YOUR_TASTE_RESULT: {
    defaultText: localeCommon.commonMessages.yourTasteTab.defaultMessage,
    tabCode: 'YOUR_TASTE_RESULT',
    text: localeCommon.commonMessages.yourTasteTab,
  },
} as const;

export type TCatalogTabCode = keyof typeof CATALOG_TABS;
